import { useCallback } from 'react';
import { NodeEntityTypes } from '../canvas-types';
import { useSweepCanvasPropsCtx } from '../internal-context/SweepCanvasPropsCtx';

export const useHandleDeleteSection = () => {
  const { onNodeClick } = useSweepCanvasPropsCtx();

  const handleDeleteSection = useCallback(
    (event: React.MouseEvent, sectionId: string) => {
      onNodeClick?.({
        entity: { type: NodeEntityTypes.SectionDelete },
        id: sectionId,
        event,
      });
    },
    [onNodeClick],
  );

  return {
    handleDeleteSection,
  };
};
